import { supabase } from "@/integrations/supabase/client";

export interface JobFavourite {
  id: string;
  user_id: string;
  job_id: string;
  created_at: string;
}

export async function listFavouriteJobIds(userId: string): Promise<string[]> {
  const { data, error } = await supabase
    .from("job_favourites")
    .select("job_id")
    .eq("user_id", userId);
  if (error) throw error;
  return (data ?? []).map((r) => r.job_id as string);
}

export async function addFavourite(userId: string, jobId: string) {
  const { error } = await supabase
    .from("job_favourites")
    .insert({ user_id: userId, job_id: jobId });
  if (error && error.code !== "23505") throw error;
}

export async function removeFavourite(userId: string, jobId: string) {
  const { error } = await supabase
    .from("job_favourites")
    .delete()
    .eq("user_id", userId)
    .eq("job_id", jobId);
  if (error) throw error;
}
